import PrivacyPolicy from "@components/shared/legal/privacyPolicy";
import { GetServerSideProps } from "next";
import { ReactElement } from "react";

import { getPageProps } from "@services/initial-calls";
import QuoteSpotWrapper from "@components/layouts/quoteSpotWrapper";

export default function QuotoHome(): ReactElement {
    return (
        <QuoteSpotWrapper>
            <PrivacyPolicy domain="QuoteSpot.com" category="B2B" />
        </QuoteSpotWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "home", {
        pageTitle: "Terms And Conditions",
    });
};
